import styled from 'styled-components';

import { Button as InnerButton } from '@xing-com/button';
import {
  spaceL,
  spaceM,
  spaceXL,
  spaceXXL,
  xdlColorBackgroundSecondary,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import {
  BodyCopy as InnerBodyCopy,
  Headline as InnerHeadline,
} from '@xing-com/typography';

export const Button = styled(InnerButton)`
  align-self: center;
  padding: ${spaceXL};
  min-width: 0px;
  margin: ${spaceL};
`;
export const EmptyStateCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin: ${spaceXXL} 0 0 0;
  padding: ${spaceL} ${spaceM} ${spaceL} ${spaceM};
  background-color: ${xdlColorBackgroundSecondary};
`;

export const TextLayer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spaceL} ${spaceXL};
  width: 100%;
  max-width: 510px;
`;
export const Headline = styled(InnerHeadline)`
  color: ${xdlColorTextSecondary};
  margin-right: ${spaceL};
`;

export const BodyCopy = styled(InnerBodyCopy)`
  color: ${xdlColorTextSecondary};
  margin-right: ${spaceL};
`;
